import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=4fb28029&"
import script from "./CartModal.vue?vue&type=script&lang=ts&"
export * from "./CartModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb28029')) {
      api.createRecord('4fb28029', component.options)
    } else {
      api.reload('4fb28029', component.options)
    }
    module.hot.accept("./CartModal.vue?vue&type=template&id=4fb28029&", function () {
      api.rerender('4fb28029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/cart/CartModal.vue"
export default component.exports